import { useIsMediaMode } from '@/hooks/useIsMediaMode'
import { MEDIA_MODE_DELIVERY_TEMPLATE_MARKER } from '@/utils/contentModuleForm'

/**
 * Effective media-mode for a single CM: channel flag OR persisted record OR
 * current delivery-style template marker. Form screens should pass the live
 * `deliveryStyle` so UI mode flips when a PM swaps templates mid-edit.
 */
export function useEffectiveMediaMode(input?: { deliveryStyle?: string | null; isMediaMode?: boolean | null }): {
  isMediaMode: boolean
} {
  const { isMediaMode: channelMediaMode } = useIsMediaMode()
  const fromTemplate = !!input?.deliveryStyle?.includes(MEDIA_MODE_DELIVERY_TEMPLATE_MARKER)
  const fromRecord = input?.isMediaMode === true
  return { isMediaMode: channelMediaMode || fromTemplate || fromRecord }
}
